import { observer } from "mobx-react";
import { useState } from "react";
import { Outlet, Route, useNavigate } from "react-router-dom";
import BaseCard from "../Common/Cards/BaseCard";
import { ChildAvatarDetails } from "./ChildAvatarDetails";
import { ChildDetails } from "./ChildDetails";
import { FAQButton } from "./ParentDashboard";
import { ParentDetails2 } from "./ParentDetails2";
import { ReferralGetter } from "./ReferralGetter";

export default observer(OnboardingFlow);

function OnboardingFlow() {
  return (
    <div className="flex flex-grow h-full w-full">
      {/* DESKTOP VIEW */}
      <div className="hidden bg-brij-Default h-full w-full sm:flex relative bg-hill_children bg-contain bg-no-repeat bg-bottom backdrop-opacity-50">
        <div className="p-14 flex w-full justify-center z-10">
          <div className="flex-col flex justify-center gap-10">
            <BaseCard>
              <div className="inline-flex flex-col gap-3 w-full">
                <Outlet />
              </div>
            </BaseCard>
          </div>
        </div>
      </div>

      {/* MOBILE VIEW */}
      <div className="sm:hidden flex flex-col gap-2 items-center h-full flex-grow-0 relative bg-hill_children bg-brij-Default bg-contain bg-no-repeat bg-bottom backdrop-opacity-50 w-full p-8 justify-start pb-28">
        <div className="flex flex-col gap-3 w-full h-full overflow-y-scroll">
          <Outlet />
        </div>
      </div>
      <FAQButton />
    </div>
  );
}

export interface FlowElementProps {
  next: () => void;
  back: () => void;
}
